/*###########################################################################
 // Site toast bar
 //#########################################################################*/

let toastTimer = null
let toastEl = null
let toastMessageEl = null

function getToastHost() {
  return document.getElementById('site-toast-host')
}

export function hideSiteToast() {
  const host = getToastHost()
  if (!toastEl || !host) return

  const leaving = toastEl
  leaving.classList.remove('is-visible')
  leaving.classList.add('is-leaving')
  window.clearTimeout(toastTimer)
  toastTimer = null
  toastEl = null
  toastMessageEl = null

  window.setTimeout(() => {
    if (leaving.parentNode === host) leaving.remove()
  }, 400)
}

/**
 * Show or update the bottom toast bar.
 * sticky: true keeps it open (for live progress) until replaced/dismissed.
 */
export function showSiteToast(message, { duration = 10000, sticky = false } = {}) {
  const host = getToastHost()
  if (!host || !message) return

  window.clearTimeout(toastTimer)
  toastTimer = null

  if (toastEl && toastMessageEl && host.contains(toastEl)) {
    toastMessageEl.textContent = message
    toastEl.classList.remove('is-leaving')
    toastEl.classList.add('is-visible')

    if (!sticky && duration > 0) {
      toastTimer = window.setTimeout(hideSiteToast, duration)
    }
    return
  }

  host.replaceChildren()

  const toast = document.createElement('div')
  toast.className = 'site-toast'
  toast.setAttribute('role', 'status')

  const text = document.createElement('p')
  text.className = 'site-toast__message'
  text.textContent = message

  const dismiss = document.createElement('button')
  dismiss.type = 'button'
  dismiss.className = 'site-toast__dismiss'
  dismiss.setAttribute('aria-label', 'Dismiss')
  dismiss.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  dismiss.addEventListener('click', hideSiteToast)

  toast.append(text, dismiss)
  host.append(toast)
  toastEl = toast
  toastMessageEl = text

  requestAnimationFrame(() => {
    requestAnimationFrame(() => toast.classList.add('is-visible'))
  })

  if (!sticky && duration > 0) {
    toastTimer = window.setTimeout(hideSiteToast, duration)
  }
}

export function initSiteToast() {
  if (window.__siteToastBound) return
  window.__siteToastBound = true
  window.addEventListener('site-toast', (event) => {
    const message = event.detail?.message
    if (message) showSiteToast(message, event.detail?.options || {})
  })
}
